import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FeatureArea = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  const features = [
    {
      img: "assets/img/update1/icon/feature_3_2.svg",
      title: "Proven Track Record",
      text: "With a history of successful transactions and satisfied clients, you can trust Sagama to deliver results",
    },
    {
      img: "assets/img/update1/icon/feature_3_4.svg",
      title: "Personalized Service",
      text: "We take the time to understand your unique needs and goals, tailoring our services to meet your specific requirements.",
    },
    {
      img: "assets/img/update1/icon/feature_3_1.svg",
      title: "Unmatched Expertise",
      text: "Our team of experienced professionals has in-depth knowledge of the Nigerian real estate market.",
    },
    {
      img: "assets/img/update1/icon/feature_3_3.svg",
      title: "Commitment to Integrity",
      text: " At Sagama, we operate with the highest level of integrity, transparency, and professionalism.",
    },
  ];

  return (
    <section className="space">
      <style>{`
        .feature-box {
          background: #f9f9f9;
          border-radius: 12px;
          padding: 25px 20px;
          transition: box-shadow 0.3s;
        }
        .feature-box:hover {
          box-shadow: 0 8px 25px rgba(0,0,0,0.08);
        }
        .feature-box_icon img {
          width: 50px;
          height: 50px;
          margin-bottom: 1rem;
        }
        .feature-box_title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .feature-box_text {
          font-size: 0.9rem;
          color: #555;
          line-height: 1.6;
        }
        .sub-title7 {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 1rem;
          color: #e86b24;
          margin-bottom: 0.5rem;
        }
        .sub-title7 .box {
          width: 8px;
          height: 8px;
          background: #e86b24;
          border-radius: 2px;
        }
        .sec {
          font-size: 0.95rem;
          color: #666;
          max-width: 700px;
          margin: 0 auto 2rem;
          text-align: center;
        }
      `}</style>

      <div className="container">
        <div className="title-area mb-30 text-center">
          <span className="sub-title7">
            <span className="box"></span> Why Choose Sagama?
          </span>
          <p className="sec">
            Sagama has helped multitudes become proud homeowners with secure, top‑tier properties and a seamless buying experience.
          </p>
        </div>
        <Slider {...settings} className="slider-shadow th-carousel">
          {features.map((feature, index) => (
            <div key={index} className="feature-slide px-2">
              <div className="feature-box">
                <div className="feature-box_icon">
                  <img src={feature.img} alt="icon" />
                </div>
                <div>
                  <h3 className="feature-box_title box-title">{feature.title}</h3>
                  <p className="feature-box_text">{feature.text}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default FeatureArea;